import { Typography } from '@mui/material';
import { useLocale } from '../../i18n/LocaleContext';
import { useStyles } from './NotFoundStyles';

const NotFound = () => {
  const classes = useStyles();
  const { t } = useLocale();

  return (
    <div className={classes.page}>
      <Typography variant="h3">{t('notFoundTitle')}</Typography>
      <Typography variant="body1" color="text.secondary">
        {t('notFoundMessage')}
      </Typography>
    </div>
  );
};

export default NotFound;
